export default __webpack_public_path__ + "static/media/yellow-diamond.52705533.svg";